var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660.5056 637.2096c-20.352 99.9424-89.4976 174.8992-199.3728 174.8992-117.9904 0-195.3024-83.2768-199.3728-195.712-4.0704-112.4096 113.92-270.6432 195.328-353.92 28.4672 24.9856 52.864 58.2912 81.3568 95.7696 8.1408-12.4928 24.4224-41.6512 32.5632-54.144-36.608-49.9456-77.312-91.5968-109.8752-124.9024C363.52 279.1168 204.8 470.656 204.8 612.2496 204.8 753.8176 318.72 870.4 461.1328 870.4c134.272 0 244.1472-104.0896 256.3328-237.3376-28.4672 8.32-77.312 0-56.96 4.1472z m-215.6544 62.464h24.4224c12.2112 0 24.4224-12.4928 24.4224-24.9856v-37.4784h40.704c12.1856 0 24.3968-12.4672 24.3968-24.96v-20.8384c0-12.4672-12.2112-24.96-24.4224-24.96h-40.704v-37.4784c0-12.4928-12.1856-24.9856-24.3968-24.9856h-24.4224c-12.1856 0-24.3968 12.4928-24.3968 24.9856v37.4784h-32.5632c-12.2112 0-24.3968 12.4928-24.3968 24.96v24.9856c0 12.4928 12.1856 24.9856 24.3968 24.9856h32.5632v33.3056c0 16.64 12.2112 24.9856 24.3968 24.9856z m236.0064-491.3408c-52.8896 54.144-138.3424 179.072-138.3424 254.0032 0 74.9568 61.0304 137.4208 138.3424 137.4208S819.2 537.2928 819.2 462.336c0-74.9312-85.4528-199.8592-138.3424-254.0032z",
    fill: "#f5821f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.592f6c000ed2d65362c0e38dc55efa62.svg";
export { ForwardRef as ReactComponent };